// services/api.js
// export const API_BASE = "http://localhost:8000/api";
// export const API_BASE = "https://edcbackend.lsc-india.org/api";
export const API_BASE =
  "https://lsc-india.org/backend-edc/public/api";

const getAccessToken = () =>
  sessionStorage.getItem("access_token");

const getAuthHeaders = (
  extraHeaders = {}
) => {
  const token = getAccessToken();

  return {
    ...extraHeaders,
    ...(token
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {}),
  };
};

// POST function
export const postData = async (
  endpoint,
  payload
) => {
  const res = await fetch(
    `${API_BASE}/${endpoint}`,
    {
      method: "POST",
      credentials: "include",
      headers: getAuthHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
      body: JSON.stringify(payload),
    }
  );

  const data = await res.json();

  return {
    data,
    status: res.status,
  };
};

// course GET function
export const getCourse = async (
  endpoint
) => {
  try {
    const res = await fetch(
      `${API_BASE}/${endpoint}`,
      {
        credentials: "include",
        headers: getAuthHeaders({
          Accept: "application/json",
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw data;
    }

    return data;
  } catch (error) {
    throw error;
  }
};

// Category GET function
export const getCategory = async (
  endpoint
) => {
  try {
    const res = await fetch(
      `${API_BASE}/${endpoint}`,
      {
        credentials: "include",
        headers: getAuthHeaders({
          Accept: "application/json",
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw data;
    }

    return data;
  } catch (err) {
    throw err;
  }
};

export const loginData = async (
  endpoint,
  payload
) => {
  try {
    const res = await fetch(
      `${API_BASE}/${endpoint}`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type":
            "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    const raw = await res.text();

    let data;

    try {
      data = JSON.parse(raw);
    } catch {
      data = {
        message: "Too many attempts",
      };
    }

    if (!res.ok) {
      const message =
        data?.message ||
        `Error: ${res.status}`;

      const error = new Error(message);

      error.status = res.status;
      error.retryAfter =
        res.headers.get("Retry-After");

      throw error;
    }

    /*
     * Local-development fallback:
     * If Chrome blocks the live-domain cookie while the React
     * page is on localhost, authenticated calls will use this
     * token as Authorization: Bearer <token>.
     */
    if (data?.access_token) {
      sessionStorage.setItem(
        "access_token",
        data.access_token
      );
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const getCsrfToken = async () => {
  const res = await fetch(
    `${API_BASE}/csrf-token`,
    {
      method: "GET",
      credentials: "include",
      headers: getAuthHeaders({
        Accept: "application/json",
      }),
    }
  );

  const data = await res.json();

  return data.csrf_token;
};

// get course by id
export const getCourseById = async (
  id
) => {
  try {
    const res = await fetch(
      `${API_BASE}/getcourse/${id}`,
      {
        method: "GET",
        credentials: "include",
        headers: getAuthHeaders({
          "Content-Type":
            "application/json",
          Accept: "application/json",
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw data;
    }

    return data.course;
  } catch (err) {
    console.error(
      "getCourseById error",
      err
    );

    throw err;
  }
};

// get user
export const getUser = async () => {
  try {
    const response = await fetch(
      `${API_BASE}/user`,
      {
        method: "GET",
        credentials: "include",
        headers: getAuthHeaders({
          "Content-Type":
            "application/json",
          Accept: "application/json",
        }),
      }
    );

    if (!response.ok) {
      throw new Error(
        "Failed to fetch user data"
      );
    }

    return await response.json();
  } catch (error) {
    console.error(
      "Error fetching user:",
      error
    );

    throw error;
  }
};

// Logout and clear auth data
export const logoutUser = async () => {
  try {
    const res = await fetch(
      `${API_BASE}/logout`,
      {
        method: "POST",
        credentials: "include",
        headers: getAuthHeaders({
          Accept: "application/json",
        }),
      }
    );

    const data = await res.json();

    sessionStorage.removeItem(
      "access_token"
    );

    if (!res.ok) {
      throw data;
    }

    return data;
  } catch (error) {
    sessionStorage.removeItem(
      "access_token"
    );

    throw error;
  }
};

export const getEnrolledCourses =
  async () => {
    try {
      const res = await fetch(
        `${API_BASE}/user/enrolled-courses`,
        {
          method: "GET",
          credentials: "include",
          headers: getAuthHeaders({
            "Content-Type":
              "application/json",
            Accept: "application/json",
          }),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw data;
      }

      return data;
    } catch (error) {
      console.error(
        "Error fetching enrolled courses:",
        error
      );

      throw error;
    }
  };

// Search Courses
export const searchCourses = async (
  query
) => {
  try {
    const res = await fetch(
      `${API_BASE}/search-courses?q=${encodeURIComponent(
        query
      )}`,
      {
        credentials: "include",
        headers: getAuthHeaders({
          Accept: "application/json",
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw data;
    }

    return data.results;
  } catch (error) {
    console.error(
      "Error searching courses:",
      error
    );

    throw error;
  }
};

// Refresh Token API
export const refreshToken = async () => {
  try {
    const res = await fetch(
      `${API_BASE}/refresh-token`,
      {
        method: "POST",
        credentials: "include",
        headers: getAuthHeaders({
          "Content-Type":
            "application/json",
          Accept: "application/json",
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      throw data;
    }

    if (data?.access_token) {
      sessionStorage.setItem(
        "access_token",
        data.access_token
      );
    }

    return data;
  } catch (error) {
    console.error(
      "Error refreshing token:",
      error
    );

    throw error;
  }
};

// Batch course API
export const getCourseBatch = async (
  categoryId = null
) => {
  try {
    const url = categoryId
      ? `${API_BASE}/course-batch?category=${categoryId}`
      : `${API_BASE}/course-batch`;

    const res = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: getAuthHeaders({
        "Content-Type":
          "application/json",
        Accept: "application/json",
      }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw data;
    }

    return data;
  } catch (error) {
    console.error(
      "Error fetching batch courses:",
      error
    );

    throw error;
  }
};

// forget password
export const resetPassword = async (
  data
) => {
  try {
    const res = await fetch(
      `${API_BASE}/reset-password`,
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
        },
        body: JSON.stringify(data),
      }
    );

    const result = await res.json();

    if (!res.ok) {
      return result;
    }

    return result;
  } catch (error) {
    throw error;
  }
};

export const accessReset = async (
  id
) => {
  try {
    const response = await fetch(
      `${API_BASE}/reset-token-verify/${id}`,
      {
        method: "GET",
      }
    );

    return await response.json();
  } catch (err) {
    console.error("Error:", err);

    return {
      status: false,
      message:
        "Something went wrong!",
    };
  }
};